import { computeScores } from "@smartmed/scoring";
import { useMemo } from "react";

interface ScoreDisplayProps {
  aiDiagnoses: string[];
  aiProcedures: string[];
  aiFlaggedForReview: boolean;
  humanDiagnoses: string[];
  humanProcedures: string[];
}

export function ScoreDisplay({
  aiDiagnoses,
  aiProcedures,
  aiFlaggedForReview,
  humanDiagnoses,
  humanProcedures,
}: ScoreDisplayProps) {
  const scores = useMemo(
    () =>
      computeScores(
        { diagnoses: aiDiagnoses, procedures: aiProcedures, aiFlaggedForReview },
        { diagnoses: humanDiagnoses, procedures: humanProcedures },
      ),
    [aiDiagnoses, aiProcedures, aiFlaggedForReview, humanDiagnoses, humanProcedures],
  );

  const primaryMatch = scores[2].value === 1;
  const opcsOrderMatch = scores[1].value === 1;
  const secondariesPct = scores[3].value;
  const overcodingPct = scores[4].value;

  return (
    <div className="flex items-center gap-3 text-xs text-gray-500">
      <span className="font-medium">Scoring:</span>
      <span>Primary {primaryMatch ? "✅" : "❌"}</span>
      <span>OPCS-4 order {opcsOrderMatch ? "✅" : "❌"}</span>
      <span>Secondaries: {formatPct(secondariesPct)}</span>
      <span>Overcoding: {formatPct(overcodingPct)}</span>
    </div>
  );
}

function formatPct(value: number): string {
  return `${Math.round(value * 100)}%`;
}
